import { yupResolver } from '@hookform/resolvers/yup';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';

import { OEButton, OEText, OETextInput } from '../../atoms';
import { mt } from '../../style-utils';

export interface ChangePasswordFormProps {
  accountName?: string | null;
  labels: {
    currentPasswordLabel?: string;
    newPasswordLabel: string;
    confirmPasswordLabel: string;
    buttonSubmit: string;
  };
  errorMessage?: string;
  isLoading?: boolean;
  onSubmit: (data: ChangePasswordFormData) => void;
  onResetValidation?: () => void;
  isCurrentPasswordRequired?: boolean;
  formSchema?: yup.ObjectSchema<ChangePasswordFormData>;
}

export type ChangePasswordFormData = {
  confirmPassword: string;
  currentPassword: string;
  password: string;
};

export const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({
  labels,
  errorMessage,
  isLoading = false,
  onSubmit,
  isCurrentPasswordRequired = true,
  formSchema,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ChangePasswordFormData>(
    formSchema
      ? {
          resolver: yupResolver(formSchema),
        }
      : {}
  );

  return (
    <>
      {!!isCurrentPasswordRequired && (
        <Controller
          control={control}
          name="currentPassword"
          render={({ field: { onChange, value } }) => (
            <>
              <OETextInput
                label={labels.currentPasswordLabel}
                autoComplete="password"
                textContentType="password"
                onChangeText={onChange}
                value={value}
                style={mt(12)}
                secure
              />
              {errors.currentPassword && (
                <ErrorMessage>{errors.currentPassword.message}</ErrorMessage>
              )}
              <Line />
            </>
          )}
        />
      )}
      <Controller
        control={control}
        name="password"
        render={({ field: { onChange, value } }) => (
          <>
            <OETextInput
              label={labels.newPasswordLabel}
              autoComplete="password"
              textContentType="password"
              onChangeText={onChange}
              value={value}
              style={mt(12)}
              secure
            />
            {errors.password && (
              <ErrorMessage>{errors.password.message}</ErrorMessage>
            )}
          </>
        )}
      />{' '}
      <Controller
        control={control}
        name="confirmPassword"
        render={({ field: { onChange, value } }) => (
          <>
            <OETextInput
              label={labels.confirmPasswordLabel}
              autoComplete="password"
              textContentType="password"
              onChangeText={(val) => onChange(val)}
              value={value}
              style={mt(12)}
              secure
            />
            {errors.confirmPassword && (
              <ErrorMessage>{errors.confirmPassword.message}</ErrorMessage>
            )}
          </>
        )}
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <SubmitButton loading={isLoading} onPress={handleSubmit(onSubmit)}>
        {labels.buttonSubmit}
      </SubmitButton>
    </>
  );
};

export default ChangePasswordForm;

const Line = styled.View`
  height: 2px;
  background: ${({ theme }) => theme.color.border};
  margin: 18px 0 0;
`;
const SubmitButton = styled(OEButton)`
  margin-top: 24px;
  align-self: center;
`;
const ErrorMessage = styled(OEText)`
  font-size: 12px;
  color: ${({ theme }) => theme.color.danger};
`;
